import { DEMO_CALCULATOR_STEP } from 'config/constants'
import { useEffect, useState } from 'react'

import { isDemoPage } from '../../../../../utils/hooks'
import { DEMO_MAIN_SAVE_EVENT } from '../../playback-constants'

export const useDemoMain = (orderId: string) => {
  const isDemoMode = isDemoPage()
  const [ isSaved, setIsSaved ] = useState(false)

  useEffect(() => {
    if (!isDemoMode) {
      return
    }

    const handleSave = () => setIsSaved(true)

    window.addEventListener(DEMO_MAIN_SAVE_EVENT, handleSave)

    return () => window.removeEventListener(DEMO_MAIN_SAVE_EVENT, handleSave)
  }, [ isDemoMode ])

  return (!orderId || isDemoMode) && !isSaved
}

export const useDemoMainForm = () => {
  const isDemoMode = isDemoPage()

  return {
    fieldProps: {
      'data-demo-playback-field': isDemoMode ? DEMO_CALCULATOR_STEP.MAIN : undefined,
    },
    saveProps: {
      'data-demo-playback-action': isDemoMode ? DEMO_CALCULATOR_STEP.MAIN : undefined,
    },
  }
}

